import $ from 'jquery';
const CLASS = 'news-pp';
const SELECTOR = '.' + CLASS;
class News {
    constructor(el) {
        this.el = $(el);

        this.moreButton = this.el.find(SELECTOR + "__load-more");
        this.moreButton.click( event => {
            event.preventDefault();
            this.loadMore(this.moreButton.attr('href'));
        })
    }

    loadMore(url) {
        this.el.toggleClass(CLASS + '--loading', true);


        $.ajax( {
            url: url,
            success: response => {
                this.addData(response);
            },
            error: e => {
                this.onError(e);
            }
        })
    }

    addData(data) {
        this.el.toggleClass(CLASS + '--loading', false);
        this.el.toggleClass(CLASS + '--loaded', true);
        this.el.find('.row').after($(data.view));

        if(data.hasOwnProperty('moreUrl')) {
            this.moreButton.attr('href', data.moreUrl);
        } else {
            this.moreButton.hide();
        }
    }

    onError(e) {
        console.error(e);
    }
}

export const list = function() {
    const elements = $(SELECTOR);
    if(elements.length) {
        elements.each( (index,el) => new News(el));
    }
};
